// extracted by mini-css-extract-plugin
export default {"searchInput":"List_searchInput__NVb9h","item":"List_item__CbtAK"};